import { render, staticRenderFns } from "./CategoryCount.vue?vue&type=template&id=b350e7b0&scoped=true&"
import script from "./CategoryCount.vue?vue&type=script&lang=js&"
export * from "./CategoryCount.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCount.vue?vue&type=style&index=0&id=b350e7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b350e7b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VIcon,VProgressCircular})
